import { useSelectedOrgUnit } from '@retail/app/stores/selected-context';
import { useMemo } from 'react';
import { AssortmentTypes, CalculusArea, ConditionState, PackageType } from '@retail/calculus/types';
import { DiscountGroup, HierarchyLevels, ProductGroupCount } from '@retail/products/types';
import { useFetchConditionFilterOptions } from '@retail/calculus/data-access';
import { useFilters } from '@retail/products/hooks';
import { CalculusFilters, calculusFilters, SelectedFilters } from '@retail/products/utils';

interface Props {
  supplierNumber?: number;
  conditionType?: CalculusArea;
}

export function useCalculusFilters({ supplierNumber, conditionType }: Props) {
  const { assortmentId } = useSelectedOrgUnit();

  const { filters } = useFilters<CalculusFilters>(calculusFilters);

  const { data: filterOptions } = useFetchConditionFilterOptions({
    assortmentId,
    conditionType,
    supplierNumber,
    conditionState: filters.conditionState as ConditionState,
    assortmentType: filters.assortmentType as AssortmentTypes,
  });

  const productGroups = useMemo(
    () =>
      filterOptions?.productGroups
        ? filterOptions.productGroups.map(ProductGroupCount.fromDto)
        : [],
    [filterOptions?.productGroups]
  );
  const discountGroups = useMemo(
    () =>
      filterOptions?.dicountGroups ? filterOptions.dicountGroups.map(DiscountGroup.fromDto) : [],
    [filterOptions?.dicountGroups]
  );

  return {
    productGroups,
    discountGroups,
    filters: {
      ...filters,
      conditionState: filters.conditionState as ConditionState,
      assortmentType: filters.assortmentType as AssortmentTypes,
      hierarchyLevel: filters.hierarchyLevel as PackageType | HierarchyLevels,
    } satisfies SelectedFilters<CalculusFilters>,
  };
}
